/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#card-element[_ngcontent-%COMP%]{border:1px solid #bdbdbd;transition:border-color .3s;padding:10px}#card-element[_ngcontent-%COMP%]:focus{border-color:#3276b1}.has-error[_ngcontent-%COMP%]   #card-element[_ngcontent-%COMP%]{border-color:#b94a48}\n/*# sourceMappingURL=stripe-payment-modal.component.css.map*/"];
export { styles as styles };
